/*
 * Copyright (c) 2023 Your Company Name
 * All rights reserved.
 */
/*
 *   Copyright (c) 2023
 *   All rights reserved.
 */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
//import Checkbox from "@material-ui/core/Checkbox";

// material-ui icons
import Assignment from "@material-ui/icons/Assignment";

import Refresh from "@material-ui/icons/Refresh";

import * as notif from "components/Notification/notification";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/Table.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";

import FormControl from "@material-ui/core/FormControl";
//import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

import stylesAlert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import stylesRegularForm from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import { useHistory, useRouteMatch } from "react-router-dom";
import {
  loadPaiementAction,
  deletePaiementAction,
} from "action/paiementAction";
import { connect } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import { useState } from "react";
import { useCallback } from "react";
import { useEffect } from "react";
import { Search } from "@material-ui/icons";
import CustomInput from "components/CustomInput/CustomInput";

import stylesSelect from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";

import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Checkbox, FormControlLabel } from "@mui/material";

import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import Stack from "@mui/material/Stack";
import { saveRelanceClientInfo } from "services/paiementService";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom-v5-compat";
//import {Checkbox as CheckboxMat}  from "@material-ui/core/Checkbox";
//import {Checkbox as CheckboxMat} from "@material-ui/core";

//import product1 from "assets/img/product1.jpg";

const useStyles = makeStyles(styles);
const useStylesSelect = makeStyles(stylesSelect);
const useStyleAlert = makeStyles(stylesAlert);
const useStylesRegularForm = makeStyles(stylesRegularForm);

const Paiement = (props) => {
  const [paramId, setParamId] = React.useState("");
  const actualURL = useRouteMatch();
  const [selectFilter, setSelectFilter] = React.useState("");
  const [tableData, setTableData] = useState([]);
  const [tableDataToShow, setTableDataToShow] = useState([]);
  const history = useNavigate();
  const {
    loadPaiementFromSaga,
    paiementLoadDispatch,
    paiementDeleteDispatch,
  } = props;
  const [alert, setAlert] = React.useState(null);
  const [deleteStatut, setDeleteStatut] = React.useState(false);
  const [
    openFormRelanceClientDialog,
    setOpenFormRelanceClientDialog,
  ] = React.useState(false);
  const [commentaireRappel, setcommentaireRappel] = React.useState("");
  //const [dateProchainRappel, setdateProchainRappel] = React.useState(new Date());
  // const [activeRappel, setActiveRappel] = useState(true)
  const [valueDateRappel, setValueDateRappel] = React.useState(new Date());
  const [
    checkedStatusRappelPayementDialog,
    setCheckedStatusRappelPayementDialog,
  ] = useState(true);
  const [emailRappelDialog, setEmailRappelDialog] = useState("");
  const [checkboxRappelGlobal, setCheckboxRappelGlobal] = useState(false);

  const handleChangeDateRappel = (value) => {
    setValueDateRappel(value);
  };

  const handleChangeStatusRappelDialog = (value) => {
    setCheckedStatusRappelPayementDialog(value.target.checked);
  };

  const handleClickOpenDialog = (data) => {
    setOpenFormRelanceClientDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenFormRelanceClientDialog(false);
  };

  const handledCheckboxRappelPaiementGlobal = (value) => {
    console.log("checkbox = ", value.target.checked);
    setCheckboxRappelGlobal(value.target.checked);
  };
  //value.target.checked

  const handleSaveDialog = () => {
    const dataToSend = {
      emailClient: emailRappelDialog,
      commentaire: commentaireRappel,
      dateProchainRappel: moment(valueDateRappel).format("YYYY-MM-DD HH:mm:ss"),
      active: checkedStatusRappelPayementDialog,
    };
    saveRelanceClientInfo(dataToSend)
      .then((res) => {
        dispatchRefreshTable();
        handleCloseDialog();
      })
      .catch((error) => {
        console.log("error = ", error);
      });
    //setOpenFormRelanceClientDialog(false);
  };

  useEffect(() => {
    if (checkboxRappelGlobal === true) {
      const dateNow = moment(new Date());

      const tab = tableData.filter((table) => {
        if (table.length >= 12) {
          const dateRapel = moment(table[11]);
          const diffInDays = dateRapel.diff(dateNow, "days");
          //console.log("dateRapel => ", table[11]);
          return (
            table[12].props.checked === true &&
            (diffInDays < 0 || table[11] === "")
          );
        }
      });
      setTableDataToShow(tab);
      // console.log("tabDataToShow", tableData)
    } else {
      setTableDataToShow(tableData);
    }
  }, [tableData, checkboxRappelGlobal]);

  const dispatchRefreshTable = useCallback(() => {
    // console.log("PARAM = ", paramId);
    //if (paramId)
    {
      const data = {
        identifiantClient: paramId,
        filtre: selectFilter,
      };
      paiementLoadDispatch(data);
    }
  }, [paiementLoadDispatch, selectFilter]);

  const handleSelectFilter = (event) => {
    setSelectFilter(event.target.value);
  };

  const loadCardFromSagaUnique = useCallback(() => {
    return loadPaiementFromSaga;
  }, [loadPaiementFromSaga]);

  useEffect(() => {
    dispatchRefreshTable();
  }, [dispatchRefreshTable]);

  useEffect(() => {
    if (deleteStatut === true) {
      if (loadPaiementFromSaga.loading === false) {
        let msg;
        let title;
        if (loadPaiementFromSaga.error.length > 0) {
          title = "Echeque Supression paiement";
          msg = "La paiement n a pas ete suprime";
          notif.showFailedNotification(title, msg);
        } else {
          title = "Supression paiement";
          msg = "La paiement   a ete suprimer";
          notif.showSuccessNotification(title, msg);
          setAlert(
            <SweetAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="Suprimer!"
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              confirmBtnCssClass={
                classesAlert.button + " " + classesAlert.success
              }
            >
              Cette article a ete supprimer.
            </SweetAlert>
          );
        }
        setDeleteStatut(false);
      }
    }
  }, [deleteStatut, loadPaiementFromSaga]);

  const paramURLID = useParams().id;

  useEffect(() => {
    setParamId(paramURLID);
  }, []);

  const handleRefresh = () => {
    if (paramId) {
      const data = {
        identifiantClient: paramId,
      };
      //  console.log("*** handleRefresh *** = ",data)
      paiementLoadDispatch(data);
    }
  };

  const successDelete = (id) => {
    const data = {
      numeroDeSeriePaiement: id,
    };

    paiementDeleteDispatch(data);
    setDeleteStatut(true);
    /*
    
    */
  };
  const cancelDetele = () => {
    setAlert(
      <SweetAlert
        danger
        style={{ display: "block", marginTop: "-100px" }}
        title="Annuler"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classesAlert.button + " " + classesAlert.success}
      >
        Votre article n a pas ete supprimer
      </SweetAlert>
    );
  };
  const hideAlert = () => {
    setAlert(null);
  };

  /*
active: true
dateReceptionPaiement: "2020-11-11T00:00:00.000+00:00"
etatPaiement: "new"
identifiantPaiement: 8
numeroPaiement: "778188858"
numeroDeCommandePaiement: "command"
numeroDeSeriePaiement: "444433"
*/

  const warningWithConfirmAndCancelMessage = (id) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Etes vous sure ?"
        onConfirm={() => successDelete(id)}
        onCancel={() => cancelDetele()}
        confirmBtnCssClass={classesAlert.button + " " + classesAlert.success}
        cancelBtnCssClass={classesAlert.button + " " + classesAlert.danger}
        confirmBtnText="Suprimer!"
        cancelBtnText="Annuler"
        showCancel
      >
        Vous ne pourez pas recuperer cette article!
      </SweetAlert>
    );
  };

  const classes = useStyles();
  const classesSelect = useStylesSelect();
  const classesAlert = useStyleAlert();
  const classesRegularForm = useStylesRegularForm();

  const handleButRappelPaiement = (data) => {
    //setValueDateRappel(data.)
    setCheckedStatusRappelPayementDialog(data.actif);
    setcommentaireRappel(data.commentaire);
    setEmailRappelDialog(data.email);
    handleClickOpenDialog();

    //console.log(data.commentaire)
  };

  const roundButtons = (id) => {
    const tabRound = [
      { color: "info", icon: Refresh, onClick: handleButRappelPaiement },
    ].map((prop, key) => {
      return (
        <Button
          round
          color={prop.color}
          className={classes.actionButton + " " + classes.actionButtonRound}
          key={key}
          onClick={() => {
            prop.onClick(id);
          }}
        >
          <prop.icon className={classes.icon} />
        </Button>
      );
    });
    return tabRound;
  };

  const statusDatePayement = (date, etat) => {
    if (etat === "EXPIRER") {
      return (
        <img
          style={{ width: 30, height: 30 }}
          src={require("assets/img/emergencylevel/rondrouge.png")}
          alt={"expirer"}
        />
      );
    } else if (etat === "URGENT") {
      return (
        <img
          style={{ width: 30, height: 30 }}
          src={require("assets/img/emergencylevel/rondorange.png")}
          alt={"URGENT"}
        />
      );
    } else if (etat === "GOOD") {
      return (
        <img
          style={{ width: 30, height: 30 }}
          src={require("assets/img/emergencylevel/rondvert.png")}
          alt={"Dans les temps"}
        />
      );
    }
  };

  useEffect(() => {
    const tabLoad = loadPaiementFromSaga.paiements;

    //console.log('***** Tab Load *********', tabLoad)
    let table = [];
    let cnt = 0;
    if (tabLoad !== undefined) {
      table = tabLoad.map((row) => {
        cnt++;
        if (row.clientMail === "tapharule@gmail.com") {
          console.log("tab  load ", row);
        }
        const commentaire =
          row.rappelPaiementCommentaire !== undefined
            ? row.rappelPaiementCommentaire
            : "";
        const dateProchainRappel =
          row.rappelPaiementDtoDateProchainRappel !== undefined
            ? row.rappelPaiementDtoDateProchainRappel
            : "";
        //const commentaire = row.rappelPaiement.commentaire !== undefined ? row.rappelPaiement.commentaire : "";
        return [
          cnt,
          statusDatePayement(row.dateExpiration, row.urgencePayement),
          row.clientMail,
          row.clientNom,
          row.numeroTel,
          row.dateExpiration,
          row.nbrDeviceActif + " / " + row.nbrTotalVehicule,
          row.datePaiement,
          row.montant,
          row.numeroTelDevice,
          commentaire,
          dateProchainRappel,
          <Checkbox
            key={cnt}
            disabled
            checked={row.rappelPaiementActive === true ? true : false}
          />,
          roundButtons({
            email: row.clientMail,
            commentaire: commentaire,
            actif: row.rappelPaiementActive,
          }),
        ];
      });
      setTableData(table);
    }
  }, [loadCardFromSagaUnique]);

  useEffect(() => {
    console.log(
      "valueRap  => ",
      moment(valueDateRappel).format("DD/MM/YYYY HH:mm:ss")
    );
  }, [valueDateRappel]);

  return (
    <GridContainer>
      {alert}
      <Dialog open={openFormRelanceClientDialog} onClose={handleCloseDialog}>
        <DialogTitle>Rappel Payement</DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>

          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Stack spacing={3}>
              <MobileDatePicker
                label="Date relance"
                inputFormat="DD/MM/YYYY"
                value={valueDateRappel}
                onChange={handleChangeDateRappel}
                renderInput={(params) => <TextField {...params} />}
              />
            </Stack>
          </LocalizationProvider>
          <TextField
            autoFocus
            margin="dense"
            id="commentaire"
            label="Commentaire"
            type="text"
            fullWidth
            variant="standard"
            value={commentaireRappel}
            onChange={(e) => {
              setcommentaireRappel(e.target.value);
            }}
          />

          <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
            <FormControlLabel
              control={
                <Checkbox
                  checked={checkedStatusRappelPayementDialog}
                  onChange={handleChangeStatusRappelDialog}
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
              label="Actif"
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          {/* <div style={{position: 'absolute', left: 20, bottom: 30}}>AAAA</div>  */}
          <Button onClick={handleCloseDialog}>Close</Button>
          <Button onClick={handleSaveDialog}>Save</Button>
        </DialogActions>
      </Dialog>

      <GridItem xs={12}>
        <div className="d-flex justify-content-end">
          <Button
            className="mr-2"
            color="info"
            onClick={() => {
              handleRefresh();
            }}
            disabled={false}
          >
            Refresh List
          </Button>
          <Button
            className="mr-2"
            color="info"
            onClick={() => {
              history(`${actualURL.url}/new`);
            }}
            disabled={false}
          >
            Ajouter paiement
          </Button>
        </div>
        <Card>
          <CardHeader color="info" icon>
            <CardIcon color="info">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Paiement</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={5}>
                <FormControl
                  fullWidth
                  className={classesSelect.selectFormControl}
                >
                  <InputLabel
                    htmlFor="simple-select"
                    className={classesSelect.selectLabel}
                  >
                    Filtre
                  </InputLabel>
                  <Select
                    MenuProps={{
                      className: classesSelect.selectMenu,
                    }}
                    classes={{
                      select: classesSelect.select,
                    }}
                    value={selectFilter}
                    onChange={handleSelectFilter}
                    inputProps={{
                      name: "selectFilter",
                      id: "simple-select",
                    }}
                  >
                    <MenuItem
                      disabled
                      classes={{
                        root: classesSelect.selectMenuItem,
                      }}
                    >
                      Filtre
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classesSelect.selectMenuItem,
                        selected: classesSelect.selectMenuItemSelected,
                      }}
                      value="tous"
                    >
                      Tous
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classesSelect.selectMenuItem,
                      }}
                      value="expire_et_capte"
                    >
                      Expirer et fonctionnel
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classesSelect.selectMenuItem,
                      }}
                      value="expire_et_capte_pas"
                    >
                      Expirer et non fonctionnel
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classesSelect.selectMenuItem,
                      }}
                      value="expire"
                    >
                      Expirer
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classesSelect.selectMenuItem,
                      }}
                      value="enRegle"
                    >
                      En regle
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classesSelect.selectMenuItem,
                      }}
                      value="expireBientot"
                    >
                      Urgent
                    </MenuItem>
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} sm={5}>
                <div
                  style={{ paddingTop: 15 }}
                  className={classesRegularForm.checkboxAndRadio}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        tabIndex={-1}
                        onChange={handledCheckboxRappelPaiementGlobal}
                        value={checkboxRappelGlobal}
                        //checkedIcon={<Check className={classes.checkedIcon} />}
                        //icon={<Check className={classes.uncheckedIcon} />}
                        classes={{
                          checked: classesRegularForm.checked,
                          root: classesRegularForm.checkRoot,
                        }}
                      />
                    }
                    classes={{
                      label: classesRegularForm.label,
                      root: classesRegularForm.labelRoot,
                    }}
                    label="Masquer relance desactiver"
                  />
                </div>
              </GridItem>

              <GridItem xs={12} sm={2}>
                <CustomInput
                  labelText="Rechercher"
                  id="Rechercher"
                  formControlProps={{
                    fullWidth: false,
                  }}
                  inputProps={{}}
                />
              </GridItem>
            </GridContainer>

            <Table
              tableHead={[
                "#",
                "status",
                "email",
                "Nom",
                "numero",
                "Expiration",
                "Status Device",
                "Date Payement",
                "montant",
                "sim device",
                "comentaire",
                "relance",
                "status",
                "Action",
              ]}
              tableData={tableDataToShow}
              customCellClasses={[classes.center, classes.right, classes.right]}
              customClassesForCells={[0, 4, 5]}
              customHeadCellClasses={[
                classes.center,
                classes.right,
                classes.right,
              ]}
              customHeadClassesForCells={[0, 4, 5]}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

const mapStateToProps = (state) => {
  //console.log('Paiement mapStateToProps ', state.paiements)
  return {
    loadPaiementFromSaga: state.paiements,
  };
};

const mapsDispatchToProps = (dispatch) => {
  return {
    paiementLoadDispatch: (data) => {
      dispatch(loadPaiementAction(data));
    },
    paiementDeleteDispatch: (data) => {
      dispatch(deletePaiementAction(data));
    },
  };
};

export default connect(mapStateToProps, mapsDispatchToProps)(Paiement);
